import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faHome,
  faDesktop,
  faMoneyCheckAlt,
  faAddressCard,
  faIdCard,
  faMoneyCheck,
  faCalendarMinus,
  faCalendar,
  faCheckSquare,
  faHandsHelping,
  faPeopleArrows,
  faSearch,
  faUsers,
  faUserTie,
  faAward,
  faIndustry,
  faComments,
  faWarehouse,
  faBoxOpen,
  faUniversity,
  faTable,
  faBars,
  faLayerGroup,
  faList,
  faReceipt,
  faHandHoldingDollar,
  faDatabase,
  faSackDollar,
  faFilter,
  faXmark,
  faCircleXmark,
  faListOl,
  faRectangleList,
  faScroll,
  faTableList,
  faMoneyBills,
  faGlobe,
  faMapLocationDot,
  faCirclePlay,
  faFileContract,
  faPoo,
  faPoop,
  faMoneyBillTransfer,
  faCommentsDollar,
  faChartBar,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faHome,
  faDesktop,
  faMoneyCheckAlt,
  faAddressCard,
  faIdCard,
  faMoneyCheck,
  faCalendarMinus,
  faCalendar,
  faCheckSquare,
  faHandsHelping,
  faPeopleArrows,
  faSearch,
  faUsers,
  faUserTie,
  faAward,
  faIndustry,
  faComments,
  faWarehouse,
  faBoxOpen,
  faUniversity,
  faTable,
  faBars,
  faLayerGroup,
  faList,
  faReceipt,
  faHandHoldingDollar,
  faDatabase,
  faSackDollar,
  faFilter,
  faXmark,
  faCircleXmark,
  faListOl,
  faRectangleList,
  faScroll,
  faTableList,
  faMoneyBills,
  faGlobe,
  faMapLocationDot,
  faCirclePlay,
  faFileContract,
  faPoo,
  faPoop,
  faMoneyBillTransfer,
  faCommentsDollar,
  faChartBar
);

// import "@fortawesome/fontawesome-free/js/fontawesome";
// import "@fortawesome/fontawesome-free/js/solid";
